module.exports = __webpack_public_path__ + "static/media/9DESA36.b3798383.jpg";